import styled from "styled-components";
import { Spinner } from "styles/components";
import { Button } from "styles/elements";
import { FlexRow } from "styles/layout";
import { Theme } from "theme";

export const ButtonContainer = styled(FlexRow)`
  justify-content: center;
  column-gap: 15px;
  margin: ${Theme.bigPanelPaddingVertical};
`;

export const GroupsButton = styled(Button)`
  padding: 4px 8px;
  width: 110px;
`;

export const GroupItemContainer = styled(FlexRow)`
  padding: ${Theme.bigPanelPadding};
`;

export const GroupName = styled.div`
  font-weight: 500;
`;

export const MembershipStatus = styled.div`
  margin-left: auto;
`;

export const GroupsLoadingSpinner = styled(Spinner)`
  border-width: ${Theme.spinnerSmallBorderWidth};
  width: 20px;
  height: 20px;
  margin: ${Theme.bigPanelPaddingVertical} auto;
`;
